import React from 'react';
import { MdHistory, MdPerson, MdLocationOn } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import TableLoadingWrapper from './TableLoadingWrapper';
import '../../styles/views.css';

const AuditLogsView = ({
  pagedFilteredData,
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  loading,
  userRole,
  userMmdaId,
}) => {
  const getActionTypeColor = (actionType) => {
    switch (actionType?.toLowerCase()) {
      case 'create':
      case 'add':
        return { bg: '#e8f5e8', color: '#2e7d32' };
      case 'update':
      case 'edit':
        return { bg: '#fff3cd', color: '#856404' };
      case 'delete':
      case 'remove':
        return { bg: '#ffebee', color: '#c62828' };
      case 'login':
      case 'access':
        return { bg: '#e3f2fd', color: '#1976d2' };
      default:
        return { bg: '#f5f5f5', color: '#666' };
    }
  };

  return (
    <>
      {/* Header */}
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <input
          type="text"
          placeholder="Search regional audit logs..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            width: 300,
            padding: '8px 12px',
            borderRadius: 4,
            border: '1px solid #ccc',
            fontSize: 16,
            outline: 'none',
          }}
        />
        
        <div style={{
          padding: '10px 16px',
          backgroundColor: '#fff3cd',
          color: '#856404',
          border: '1px solid #ffeaa7',
          borderRadius: 6,
          fontSize: 14,
          fontWeight: 'bold',
        }}>
          Regional Activity Logs
        </div>
      </div>

      {/* Audit Logs Table */}
      <TableLoadingWrapper loading={loading}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>User</th>
                <th>Action Type</th>
                <th>Description</th>
                <th>Zone</th>
                <th>IP Address</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => {
                const actionStyle = getActionTypeColor(row.action_type);
                return (
                  <tr key={i} style={{ cursor: 'default' }}>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <MdHistory size={16} style={{ color: '#666' }} />
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                            {new Date(row.timestamp || row.created_at).toLocaleDateString()}
                          </div>
                          <div style={{ fontSize: 11, color: '#666' }}>
                            {new Date(row.timestamp || row.created_at).toLocaleTimeString()}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <MdPerson size={14} style={{ color: '#1976d2' }} />
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                            {row.user_name || row.full_name || 'System'}
                          </div>
                          <div style={{ fontSize: 11, color: '#666' }}>
                            {row.user_role || 'N/A'}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: 12,
                        fontWeight: 'bold',
                        backgroundColor: actionStyle.bg,
                        color: actionStyle.color
                      }}>
                        {(row.action_type || 'unknown').toUpperCase()}
                      </span>
                    </td>
                    <td>
                      <div style={{ maxWidth: '200px', fontSize: 12 }}>
                        {row.description || row.action_description || 'No description available'}
                      </div>
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <MdLocationOn size={14} style={{ color: '#1976d2' }} />
                        <span style={{
                          padding: '4px 8px',
                          backgroundColor: '#e3f2fd',
                          borderRadius: 4,
                          fontSize: 12,
                          color: '#1976d2'
                        }}>
                          {row.zone_name || 'N/A'}
                        </span>
                      </div>
                    </td>
                    <td>
                      <span style={{ fontFamily: 'monospace', fontSize: 11 }}>
                        {row.ip_address || 'N/A'}
                      </span>
                    </td>
                    <td>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: 12,
                        fontWeight: 'bold',
                        backgroundColor: row.status === 'success' ? '#e8f5e8' : '#ffebee',
                        color: row.status === 'success' ? '#2e7d32' : '#c62828'
                      }}>
                        {(row.status || 'success').charAt(0).toUpperCase() + (row.status || 'success').slice(1)}
                      </span>
                    </td>
                    <td>
                      <button
                        onClick={() => console.log('View audit log details:', row)}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#1976d2',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                        }}
                      >
                        Details
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>

      {/* Pagination */}
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      )}

      {/* Audit Logs Info */}
      <div style={{
        marginTop: 20,
        padding: 15,
        backgroundColor: '#fff3cd',
        borderRadius: 8,
        border: '1px solid #ffeaa7',
        fontSize: 14,
        color: '#856404'
      }}>
        <strong>Regional Audit Logs:</strong> Track all activities and changes within your MMDA region. 
        Monitor user actions, system changes, and maintain accountability for all operations.
      </div>
    </>
  );
};

export default AuditLogsView;
